import e from"../requiredArgs/index.js";import r from"../../toDate/index.js";export default function(t){e(1,arguments);var o=r(t),i=o.getTime();o.setUTCMonth(0,1),o.setUTCHours(0,0,0,0);var m=o.getTime(),n=i-m;return Math.floor(n/864e5)+1}
